export default __webpack_public_path__ + "static/media/tab2.ff22b6c7.svg";